import React, { Component } from 'react'
import * as utils from "../../utils";
import urls from 'urls';

import UserAvatar from "../../avatars/components";

const TagGuestsSearch = React.createClass({
  getInitialState() {
    return {
      searchTerm: "",
      listUsers: [],
      selected: 0,
      noResults: false,
      searching: false
    }
  },
  componentDidUpdate() {
    if (this.state.listUsers.length > 0) {
      this.scrollMentionlist();
      document.addEventListener('click', this.emptyListUsers, false);
    } else {
      document.removeEventListener('click', this.emptyListUsers, false);
    }
  },
  componentWillUnmount() {
    document.removeEventListener('click', this.emptyListUsers, false);
  },
  render() {
    const { listUsers, searchTerm, noResults, searching } = this.state;
    return (
      <div className="tag-guests-search">
        <input
          type="text"
          name="tag-search"
          placeholder="Tag a guest..."
          onChange={this.handleInputChange}
          onKeyDown={this.handleKeyDown}
          value={searchTerm}
          ref={(c) => this.tagSearchInput = c}
          autoComplete="off"
          autoFocus
        />
        { searching &&
          <div className="searching">
            <div className="css-spinner" />
          </div>
        }
        { this.props.handleCloseSearch &&
          <div className="close-tag-input">
            <i className="icon-cancel" onClick={this.props.handleCloseSearch} />
          </div>
        }
        { listUsers.length > 0 &&
          <div className="search-result-list">
            <ul>
              {this.listUserNodes()}
            </ul>
          </div>
        }
        { (searchTerm.length > 1 && noResults) &&
          <div className="no-results">
            <i className="icon-cancel" /> No matches found
          </div>
        }
      </div>
    )
  },
  handleInputChange(e) {
    const { tags } = this.props;
    const searchTerm = e.target.value;
    const url = urls.get('ajax_event_guestlist_search', {
      search_term: searchTerm,
      event_id: window.evite_event.id,
      gid: window.guest_id
    });

    // Abort xhr if currently in progress
    if (this.xhr && this.xhr.readyState !== 4) {
      this.xhr.abort();
    }

    // Exit if the term is the same as current result
    if (searchTerm === this.state.searchTerm) {
      return false;
    }

    // Exit and cleat listUsers if no search term
    if (searchTerm === "") {
      this.emptyListUsers();
      return false;
    }

    this.setState({
      searchTerm,
      searching: true
    });

    let filteredUsers = [];

    this.xhr = window.$.get(url, (response) => {
      if (response.length === 0) {
        this.setState({
          noResults: true
        });
      } else {
        response.map((user, idx) => {
          // filter current user from list
          if (window.user_id === user.user_id) {
            return;
          }
          // Filter tagged users from the list
          let notTagged = tags.map(function(e) {
            return e.user_id;
          }).indexOf(user.user_id) === -1;
          if (notTagged) {
            filteredUsers.push(user);
          }
        });
        this.setState({
          noResults: false
        });
      }
      this.setState({
        listUsers: filteredUsers
      });
    })
    .fail(function(jqXHR, textStatus, errorThrown) {
      if (textStatus !== "abort") {
        utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
      }
    })
    .done(() => {
      this.setState({searching: false});
    });
  },

  handleKeyDown(e) {
    if (this.state.listUsers.length > 0) {
      this.handleKeyDownOnList(e);
    } else {
      this.handleKeyDownOnInput(e);
    }
  },
  handleKeyDownOnList(e) {
    switch (e.keyCode) {
      case 13:
        // 'ENTER' key
        this.insertTagFromList(this.state.selected);
        e.preventDefault();
        break;
      case 27:
        // 'ESC' key
        this.emptyListUsers();
        break;
      case 38:
        // 'UP ARROW' key
        this.moveListSelection(-1);
        e.preventDefault();
        break;
      case 40:
        // 'DOWN ARROW' key
        this.moveListSelection(1);
        e.preventDefault();
        break;
    }
  },
  handleKeyDownOnInput(e) {
    switch (e.keyCode) {
      case 13:
        // 'ENTER' key
        e.preventDefault();
        break;
    }
  },
  moveListSelection(direction) {
    const newSelected = this.state.selected + direction;
    if (newSelected > -1 && newSelected < this.state.listUsers.length) {
      this.setState({selected: newSelected});
    }
  },
  scrollMentionlist() {
    if (document.querySelector) {
      let l = document.querySelector('.search-result-list'),
          s = document.querySelector('.search-result-list .selected');
      if ((s.offsetTop + s.offsetHeight) >= (l.offsetHeight + l.scrollTop) || l.scrollTop >= s.offsetTop) {
        l.scrollTop = s.offsetTop;
      }
    }
  },
  handleUserClick(i, e) {
    e.preventDefault();
    this.insertTagFromList(i);
    this.tagSearchInput.focus();
  },
  insertTagFromList(index) {
    const user = this.state.listUsers[index];
    this.props.handleAddTaggedGuest(user.user_id, user.primary_name);
    this.emptyListUsers();
  },
  emptyListUsers() {
    this.setState(this.getInitialState());
  },
  listUserNodes() {
    return this.state.listUsers.map((user, i) => {
      const cssClass = i === this.state.selected ? "selected" : "";
      return (
        <li className={cssClass} key={user.user_id} onClick={this.handleUserClick.bind(this, i)}>
          <UserAvatar
            userId={user.user_id}
            firstName={user.primary_name}
            lastName=""
            size="small"
          />
          {user.primary_name}
          { (user.secondary_name && user.primary_name !== user.secondary_name) &&
            <span className="secondary-name">({user.secondary_name})</span>
          }
        </li>
      );
    });
  }
});

export default TagGuestsSearch;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/tag-guests/components/tag-guests-search.es6